<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center justify-content-between catalogo-text text-sm"
          >
            Usuario
            <router-link :to="{ name: 'usuarios' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombreUsuario.$model"
                  :isValid="checkIfValid('nombreUsuario')"
                  label="Nombre del usuario:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.correo.$model"
                  :isValid="checkIfValid('correo')"
                  label="Correo electrónico:"
                  placeholder="Correo electrónico..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres, maximo 50 caracteres y cumplir con los caracteres de un email"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9">
                <label>Perfiles</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multiPerfiles"
                    :options="perfiles"
                    :loading="isLoadingPage"
                    placeholder="Selecciona uno o varios perfiles"
                    class="margin-multi"
                    :multiple="true"
                    label="label"
                    track-by="label"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multiPerfiles && multiPerfiles.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9">
                <label>Ubicaciones:</label>

                <CDataTable
                  :items="ubicaciones"
                  :fields="fieldsSub"
                  :header="false"
                  :noItemsView="noItems"
                >
                  <template #nombre="{item}">
                    <td class="py-1">{{ item.nombre }}</td>
                  </template>
                  <template #switch="{item,index}">
                    <td class="py-2 d-flex justify-content-end">
                      <CSwitch
                        v-if="item.id !== 0"
                        @update:checked="addItem(item, index)"
                        class="mx-1"
                        color="primary"
                        variant="3d"
                        :checked="item.isActive"
                      />
                      <CSwitch
                        v-else
                        @update:checked="checkAllLocations(item, index)"
                        class="mx-1"
                        color="primary"
                        variant="3d"
                        :checked="item.isActive"
                      />
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>

          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'usuarios' }">
              <CButton class="px-4 mx-3 btn-lg" @click="modal = false" color="danger">Cancelar</CButton>
            </router-link>
            <CButton class="px-4 mx-3 btn-lg" @click="addUsuario()" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      size="sm"
      title="Cultivo"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";

const fieldsSub = [
  {
    key: "nombre",
    label: "Ubicacion",
    _style: "width:40%,"
  },

  {
    key: "switch",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "EditarUsuario",

  components: {
    Multiselect
  },

  data() {
    return {
      id: this.$route.params.id,
      fieldsSub,
      item: {},
      nombreUsuario: "",
      ubicaciones: [],
      ubiRes: [],
      ubicacionesAll: [],
      multi: null,
      correo: "",
      perfiles: [],
      perfilesAll: [],
      multiPerfiles: null,
      error: "",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      warningModal: false,
      isLoading: false,
      isLoadingPage: false
    };
  },

  created() {
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customUsuarioHTTP", {
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      }),
      this.$store.dispatch("customRolHTTP"),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];

    Promise.all(ubi)
      .then(([item, perfiles, ubicaciones]) => {
        this.item = item.data[0];
        console.log(item.data);
        this.perfiles = perfiles.data.map(perfil => {
          return { value: perfil.id, label: perfil.rol };
        });
        this.ubiRes = ubicaciones.data.map(ubicacion => {
          return {
            id: ubicacion.id,
            nombre: ubicacion.payload.nombre,
            isActive: false
          };
        });
        this.ubicaciones = [
          {
            id: 0,
            nombre: "Todas las ubicaciones",
            isActive: false
          },
          ...this.ubiRes
        ];
        this.ubicacionesAll = ubicaciones.data;
        this.perfilesAll = perfiles.data;
        this.nombreUsuario = this.item.nombre;
        this.correo = this.item.correo;

        const newMult = [];
        const newUbi = [];
        this.item.roles.map(cre => {
          newMult.push(perfiles.data.find(per => per.rol == cre));
        });
        // console.log(this.item.roles);
        // console.log(newMult);
        // console.log(perfiles.data);
        let allLocations = false;

        const credencialUbi = "@catalogo:schema=ubicaciones|payload.raiz_id=";
        const ubi = [];
        this.item.credenciales.map(credencial => {
          // let newUbi = credencial;
          if (credencial == "@catalogo:schema=ubicaciones|payload.raiz_id=*") {
            allLocations = true;
          }
          if (
            credencial.includes(credencialUbi) &&
            credencial !== "@catalogo:schema=ubicaciones|payload.raiz_id=*"
          ) {
            let newUbi = credencial.replace(credencialUbi, "");
            ubi.push(newUbi);
          }
        });
        console.log(ubi);

        // Object.keys(this.item.credenciales).map(credencial => {
        //   // let newUbi = credencial;
        //   if (this.item.credenciales[credencial].includes(credencialUbi)) {
        //     let newUbi = this.item.credenciales[credencial].replace(
        //       credencialUbi,
        //       ""
        //     );
        //     ubi.push(newUbi);
        //   }
        // });
        console.log(ubicaciones.data);
        ubi.forEach(ubi => {
          newUbi.push(ubicaciones.data.find(item => item.id == ubi));
        });

        this.multi = newUbi.map(ubicacion => {
          return ubicacion ? ubicacion.id : "";
        });
        const template = {
          id: 0,
          nombre: "Todas las ubicaciones",
          isActive: true
        };
        if (allLocations) {
          this.ubicaciones = [template];
          this.multi = [0];
          this.ubiRes = this.ubiRes.map(i => {
            return { ...i, isActive: false };
          });
        }
        this.ubicaciones = this.ubicaciones.map(ubi => {
          if (this.multi.includes(ubi.id)) {
            return { ...ubi, isActive: true };
          } else {
            return ubi;
          }
        });
        // this.multi = newUbi.map(ubicacion => {
        //   return { value: ubicacion.id, label: ubicacion.payload.nombre };
        // });
        this.multiPerfiles = newMult.map(perfil => {
          return { value: perfil.id, label: perfil.rol };
        });
      })
      .finally(() => (this.isLoadingPage = false));
  },

  mixins: [validationMixin],
  validations: {
    nombreUsuario: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    correo: {
      required,
      email,
      minLength: minLength(3),
      maxLength: maxLength(50)
    }
  },

  computed: {
    ambito() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    isValidNombre() {
      return !this.$v.nombreUsuario.$invalid;
    },
    isValidCorreo() {
      return !this.$v.correo.$invalid;
    }
  },

  methods: {
    addItem(item, index) {
      // this.tiempo_extra = !this.tiempo_extra;
      if (!this.multi.includes(item.id)) {
        this.multi = [...this.multi, item.id];
        this.ubicaciones[index].isActive = !this.ubicaciones[index].isActive;
      } else {
        let exist = this.multi.findIndex(id => id == item.id);
        exist != -1 ? this.multi.splice(exist, 1) : null;
        this.ubicaciones[index].isActive = !this.ubicaciones[index].isActive;
      }
    },
    checkAllLocations(item, index) {
      this.addItem(item, index);
      const template = {
        id: 0,
        nombre: "Todas las ubicaciones",
        isActive: item.isActive
      };
      if (item.isActive) {
        this.ubicaciones = [template];
        this.multi = [0];
        this.ubiRes = this.ubiRes.map(i => {
          return { ...i, isActive: false };
        });
      } else {
        this.ubicaciones = [template, ...this.ubiRes];
      }
    },
    addUsuario() {
      this.validateUsuario();
      if (this.isValidNombre && this.isValidCorreo) {
        this.isLoading = true;
        const valuePerfiles = this.multiPerfiles
          ? this.multiPerfiles.map(item => item.label)
          : null;

        const credencialUbi = "@catalogo:schema=ubicaciones|payload.raiz_id=";
        const credencialUbiCosto = `@balance:RUTA_MODULO=${this.ambito}:C4.BALANCE_FINANCIERO.COSTO|ATRIBUTOS.UBICACION_RAIZ_ID=`;
        const credencialUbiSaldos = `@balance:RUTA_MODULO=${this.ambito}:C4.BALANCE_INVENTARIO.INVENTARIO|ATRIBUTOS_SALDO.ALMACEN_UBICACION_ID=`;
        let credencialesUbicaciones = [];
        // let credencialesPerfiles = [];

        this.multi
          ? this.multi.forEach(ubi => {
              if (ubi !== 0) {
                credencialesUbicaciones = [
                  ...credencialesUbicaciones,
                  `${credencialUbi}${ubi}`,
                  `${credencialUbiCosto}${ubi}`,
                  `${credencialUbiSaldos}${ubi}`
                ];
              } else {
                credencialesUbicaciones = [
                  `${credencialUbi}*`,
                  `${credencialUbiCosto}*`,
                  `${credencialUbiSaldos}*`
                ];
              }
            })
          : "";

        // this.multiPerfiles
        //   ? this.multiPerfiles.map(perfil => {
        //       const perfilAct = this.perfilesAll.find(
        //         p => p.id == perfil.value
        //       );
        //       perfilAct.credenciales.map(per => {
        //         if (!credencialesPerfiles.includes(per)) {
        //           credencialesPerfiles.push(per);
        //         }
        //       });
        //     })
        //   : "";

        // console.log({
        //   id: this.id,
        //   nombre: this.nombreUsuario,
        //   correo: this.correo,
        //   roles: valuePerfiles ? valuePerfiles : [],
        //   credenciales: [...credencialesUbicaciones]
        // });

        console.log(credencialesUbicaciones);

        this.$store
          .dispatch("customUsuarioActualizarHTTP", {
            id: this.id,
            nombre: this.nombreUsuario,
            correo: this.correo,
            roles: valuePerfiles ? valuePerfiles : [],
            credenciales: [...credencialesUbicaciones]
          })
          .then(() => {
            this.$router.push({ name: "usuarios" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateUsuario() {
      this.$v.nombreUsuario.$touch();
      this.$v.correo.$touch();
    },
    cleanMulti() {
      this.multiPerfiles = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
